const getHostScope = (): string => {
  if (typeof window === 'undefined') {
    return 'server';
  }

  return window.location.hostname.trim().toLowerCase() || 'default';
};

const StorageScopeService = {
  scopedKey(baseKey: string): string {
    return `${baseKey}:${getHostScope()}`;
  },
};

export default StorageScopeService;
